import { BusinessUnitEntity } from '../entities';
import { BusinessUnitRepository } from '../ports/repositories';

export class FindBusinessUnitByUseCase {
  constructor(private readonly repo: BusinessUnitRepository) {}

  async find(id: string): Promise<BusinessUnitEntity> {
    return this.repo.getById(id);
  }
}
